import {commonConfirmationBulkDelete} from "../../../../hoc/commonConfirmationBulkDelete";

const BulkRevisionDelete = commonConfirmationBulkDelete('Revision');
export default BulkRevisionDelete;
